import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

import routes from "routes";
import footerRoutes from "footer.routes";
import { Box, Container, Typography, IconButton, Paper } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import MailIcon from "@mui/icons-material/Mail";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import emailjs from "emailjs-com";
import bgImage from "assets/images/contact-us-bg.jpg";
import Slide from "@mui/material/Slide";
import MKAlert from "components/MKAlert";
import { useState } from "react";

function ContactUs() {
  const [success, setSuccess] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    message: "",
  });

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.fullName || !formData.phone || !formData.message) {
      alert("Please fill all fields");
      return;
    }

    const messageData = {
      ...formData,
      submittedTime: new Date().toLocaleString(),
    };

    emailjs
      .send(
        "service_xlukffd",
        "template_z87ttpf",
        messageData,
        "HYpNCjCXS-NiZBGXa"
      )
      .then(() => {
        setSuccess(true);
        setFormData({
          fullName: "",
          phone: "",
          message: "",
        });

        setTimeout(() => setSuccess(false), 3000);
      })
      .catch((err) => console.log("EmailJS Error:", err));
  };

  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar
          routes={routes}
          action={{
            type: "internal",
            route: "/search-artists",
            label: "Search Artists",
            color: "info",
          }}
        />
      </MKBox>

      <Slide direction="left" in={success} unmountOnExit>
        <MKBox position="absolute" top="7.5rem" right={0} width="100%">
          <MKAlert width="85%" mx="auto" color="success">
            <MKTypography variant="body2" color="white">
              📩 Your message has been sent successfully!
            </MKTypography>
          </MKAlert>
        </MKBox>
      </Slide>

      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} lg={6}>
          <MKBox
            display={{ xs: "none", lg: "flex" }}
            width="calc(100% - 2rem)"
            height="calc(100vh - 2rem)"
            borderRadius="lg"
            style={{ backgroundSize: "cover" }}
            ml={2}
            mt={2}
            sx={{ backgroundImage: `url(${bgImage})` }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={10}
          md={7}
          lg={6}
          xl={4}
          ml={{ xs: "auto", lg: 6 }}
          mr={{ xs: "auto", lg: 6 }}
        >
          <MKBox
            bgColor="white"
            borderRadius="xl"
            shadow="lg"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            mt={{ xs: 20, sm: 18, md: 20 }}
            mb={{ xs: 20, sm: 18, md: 20 }}
            mx={3}
          >
            <MKBox
              variant="gradient"
              bgColor="info"
              coloredShadow="info"
              borderRadius="lg"
              p={2}
              mx={2}
              mt={-3}
            >
              <MKTypography variant="h3" color="white">
                Contact us
              </MKTypography>
            </MKBox>
            <MKBox p={3}>
              <MKTypography variant="body2" color="text" mb={3}>
                For further questions, please email makemyshows@gmail.com or
                contact using our contact form.
              </MKTypography>
              <MKBox
                width="100%"
                component="form"
                onSubmit={handleSubmit}
                autoComplete="off"
                method="post"
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <MKInput
                      value={formData.fullName}
                      onChange={(e) => handleChange("fullName", e.target.value)}
                      variant="standard"
                      label="Full Name"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MKInput
                      value={formData.phone}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        if (value.length <= 10) {
                          handleChange("phone", e.target.value);
                        }
                      }}
                      variant="standard"
                      label="Phone Number"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      inputProps={{
                        maxLength: 10,
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                      }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MKInput
                      value={formData.message}
                      onChange={(e) => handleChange("message", e.target.value)}
                      variant="standard"
                      label="What can we help you?"
                      placeholder="Describe your plan"
                      InputLabelProps={{ shrink: true }}
                      multiline
                      fullWidth
                      rows={6}
                      required
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  justifyContent="center"
                  xs={12}
                  mt={5}
                  mb={2}
                >
                  <MKButton type="submit" variant="gradient" color="info">
                    Send Message
                  </MKButton>
                </Grid>
              </MKBox>
            </MKBox>
          </MKBox>
        </Grid>
      </Grid>

      <Box sx={{ backgroundColor: "#f7f7f7", py: 8 }}>
        <Container maxWidth="lg">
          <Typography variant="h3" fontWeight="bold" mb={6} textAlign="center">
            Get In Touch
          </Typography>

          <Grid
            container
            spacing={6}
            justifyContent="center"
            textAlign="center"
          >
            {/* Inquiry Contact */}
            <Grid item xs={12} md={4}>
              <Paper sx={cardStyle}>
                <PhoneIcon sx={iconStyle} />
                <Typography fontWeight="bold" mt={2}>
                  Inquiry Helpline
                </Typography>
                <Typography variant="h6" mt={1}>
                  +91 95282 94837
                </Typography>
              </Paper>
            </Grid>

            {/* Artist Contact */}
            <Grid item xs={12} md={4}>
              <Paper sx={cardStyle}>
                <MusicNoteIcon sx={iconStyle} />
                <Typography fontWeight="bold" mt={2}>
                  Artist Helpline
                </Typography>
                <Typography variant="h6" mt={1}>
                  +91 95282 94837
                </Typography>
              </Paper>
            </Grid>

            <Grid item xs={12} md={4}>
              <Paper sx={cardStyle}>
                <MailIcon sx={iconStyle} />
                <Typography fontWeight="bold" mt={2}>
                  Email Us
                </Typography>
                <Typography variant="h6" mt={1}>
                  makemyshows@gmail.com
                </Typography>
              </Paper>
            </Grid>
          </Grid>

          {/* Social Icons */}
          <Box mt={6} textAlign="center">
            <Typography fontWeight="bold" mb={2}>
              Follow Us
            </Typography>

            <Box>
              <IconButton sx={socialIconStyle}>
                <InstagramIcon />
              </IconButton>
              <IconButton sx={socialIconStyle}>
                <FacebookIcon />
              </IconButton>
              <IconButton sx={socialIconStyle}>
                <LinkedInIcon />
              </IconButton>
              <IconButton sx={socialIconStyle}>
                <YouTubeIcon />
              </IconButton>
            </Box>
          </Box>
        </Container>
      </Box>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

const cardStyle = {
  py: 4,
  px: 3,
  borderRadius: "16px",
  backgroundColor: "#fff",
  boxShadow: "0px 5px 20px rgba(0,0,0,0.05)",
};

const iconStyle = {
  fontSize: 40,
  width: "2em",
  height: "2em",
  background: "#eaeaea",
  color: "#d32f2f",
  padding: "10px",
  borderRadius: "50%",
};

const socialIconStyle = {
  mx: 1,
  fontSize: "28px",
  color: "#d32f2f",
  backgroundColor: "#fff",
  borderRadius: "12px",
  padding: "10px",
  boxShadow: "0px 3px 12px rgba(0,0,0,0.1)",
  "&:hover": {
    backgroundColor: "#d32f2f",
    color: "#fff",
    transform: "scale(1.1)",
  },
};
export default ContactUs;
